module.exports = __webpack_public_path__ + "img/10.922f3acc.png";